module.exports = __webpack_public_path__ + "img/asset_FIDA.f852621c.svg";